export const EmptyIndicator = ' - '
